import { action } from 'satcheljs';
import { PersonaSize } from 'fabric-persona';

const fetchPersonaPhoto = action(
    'fetchPersonaPhoto',
    (
        name: string,
        emailAddress: string,
        personaId: string,
        initialGenerationText: string,
        personaSize: PersonaSize
    ) => ({
        name,
        emailAddress,
        personaId,
        initialGenerationText,
        personaSize,
    })
);

export default fetchPersonaPhoto;
